import styled from 'styled-components';
import { Box, Grid } from '@material-ui/core';
import { LongBody } from 'components/Typography';
import { Captions } from 'components/Typography';

export const BoxGeneraleCon = styled(Box)`
  margin: 12px 0;
  p {
    margin: 0 !important;
  }
`;
export const GridChechBox = styled(Grid)`
  margin: -10px !important;
`;

export const GridConditionText = styled(Grid)`
  margin-top: -4px !important;
  margin-left: 7px !important;
`;

export const SizedLongBody = styled(LongBody)`
  && {
    margin-bottom: 0px;
  }
`;

export const StyledCaptions = styled(Captions)`
  && {
    margin-bottom: 0px;
  }
`;
